// Pure Signal identity helpers shared by the hydrated catalog and static
// built-in kernels. Backend analytics groups detections by namespace, while
// dashboard scopes and URLs use the command slug.

export const DETECTION_OVERLAY = Object.freeze({
    "security.credscan": Object.freeze({ command: "credential-material" }),
    // A signal's second namespace is NOT listed here unless it should render as
    // its own card: naming a `command` for it is what promotes it (see `_build`
    // in signalCatalog.js). A namespace whose rows analytics never returns would
    // render a permanently empty card, which reads as broken rather than absent.
    // credscan once carried a `security.credscan.review` band that was kept out
    // of this map for exactly that reason; the band has since been retired from
    // the catalog, and the classifier stage decides what reaches the graph
    // instead. The mechanism stays for the next signal that grows a second,
    // customer-visible namespace.
    "security.destructive_command": Object.freeze({ tier: "audit" }),
    "security.sensitive_path_access": Object.freeze({ tier: "audit" }),
    "security.config_shadow": Object.freeze({ subject: "endpoint" }),
    "security.guardrail_disable": Object.freeze({ subject: "endpoint" }),
    "security.session_guardrail_bypass": Object.freeze({ subject: "endpoint" }),
});

export const DETECTION_COMMAND_OVERRIDES = Object.freeze(Object.fromEntries(
    Object.entries(DETECTION_OVERLAY)
        .filter(([, overlay]) => overlay.command)
        .map(([namespace, overlay]) => [namespace, overlay.command]),
));

export function deriveDetectionCommand(namespace) {
    return String(namespace || "").replace(/^security\./, "").replace(/_/g, "-");
}

export function detectionCommandForNamespace(namespace) {
    return DETECTION_COMMAND_OVERRIDES[namespace] || deriveDetectionCommand(namespace);
}
